// Dominio por idioma: synclyst.mx (es-MX) y synclyst.com (en-US). Auditoría UI/UX A4.
export const SITE_EN = 'https://synclyst.com';
export const SITE_ES = 'https://synclyst.mx';

const host = (): string => (typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '');

/** true solo en los dominios públicos de producción (incluye www). */
export const isProdSiteHost = (h: string = host()): boolean =>
  /^(www\.)?synclyst\.(com|mx)$/.test(h);

export const isMxSite = (h: string = host()): boolean => /(^|\.)synclyst\.mx$/.test(h);

/** Origen canónico del dominio actual (fuera de prod: .com). */
export const currentSiteOrigin = (h: string = host()): string => (isMxSite(h) ? SITE_ES : SITE_EN);

export const siteLangForHost = (h: string = host()): 'es' | 'en' | undefined =>
  isProdSiteHost(h) ? (isMxSite(h) ? 'es' : 'en') : undefined;

export const htmlLangFor = (lng?: string): 'es-MX' | 'en-US' =>
  (lng || '').toLowerCase().startsWith('es') ? 'es-MX' : 'en-US';

/** URL del otro dominio conservando ruta, query y hash; añade ?lng= para fijar el idioma y, si hay
 *  elección explícita de tema (light|dark), ?theme= para que el otro dominio (otro localStorage) la conserve. */
export const crossDomainUrl = (lng: 'es' | 'en', loc: { pathname: string; search: string; hash: string }, theme?: 'light' | 'dark' | null): string => {
  const params = new URLSearchParams(loc.search);
  params.set('lng', lng);
  if (theme === 'light' || theme === 'dark') params.set('theme', theme);
  else params.delete('theme');
  const origin = lng === 'es' ? SITE_ES : SITE_EN;
  return `${origin}${loc.pathname}?${params.toString()}${loc.hash}`;
};
